module.exports = __webpack_public_path__ + "img/mihail.r__600x600.8cf404e5.jpg";